<arpio-center-panel>
  <div class="light-control-host">
    <h3 class="panel-title">Thanks for choosing {{ uiService.productName }} in the Azure Marketplace!</h3>

    <ng-container *ngIf="loading; else loadedBlock">
      <div class="margin-top"><i class="fa-solid fa-spinner fa-spin"></i> Loading subscription details...</div>
    </ng-container>

    <ng-template #loadedBlock>
      <ng-container *ngIf="subscription; else errorBlock">
        <div class="margin-top subscription-details">
          <ul id="subscription-info">
            <li><strong>Subscription ID:</strong> {{ subscription.subscriptionId }}</li>
            <li><strong>Subscription Name:</strong> {{ subscription.subscriptionName }}</li>
            <li><strong>Status:</strong> {{ subscription.status }}</li>
            <li><strong>Plan Description:</strong> {{ subscription.planDescription }}</li>
            <li><strong>Tenant ID:</strong> {{ subscription.tenantId }}</li>
            <li><strong>Tenant Name:</strong> {{ subscription.tenantName }}</li>
            <li><strong>Purchaser Name:</strong> {{ subscription.purchaserName }}</li>
            <li><strong>Purchaser Email:</strong> {{ subscription.purchaserEmail }}</li>
          </ul>
        </div>

        <div class="margin-top">
          If you are new to {{ uiService.productName }}, or would like to create an additional
          {{ uiService.productName }} account, choose "Create New Account."
        </div>
        <div class="flex-center-row">
          <div class="spacer"></div>
          <button class="arpio-button margin-top" (click)="newAccountClick()" [disabled]="activating">
            <ng-container *ngIf="activating"><i class="fa-solid fa-spinner fa-spin"></i></ng-container>
            CREATE NEW ACCOUNT
          </button>
          <div class="spacer"></div>
        </div>
        <div class="margin-top">
          If you have an existing {{ uiService.productName }} account, and would like to associate your Azure
          Marketplace subscription with that account, choose "Link Existing Account."
        </div>
        <div class="flex-center-row">
          <div class="spacer"></div>
          <button class="arpio-button margin-top" (click)="existingAccountClick()">LINK EXISTING ACCOUNT</button>
          <div class="spacer"></div>
        </div>
      </ng-container>

      <ng-template #errorBlock>
        <div class="margin-top">Unable to load subscription details. Please try again or contact support.</div>
      </ng-template>
    </ng-template>
  </div>
</arpio-center-panel>
